import { z } from "zod/v4";
import { Amount } from "./amount";
const TaxCategoryList = ["Taxable10", "Taxable8", "UnTaxable"];
const TaxCategoryProperties = {
    Taxable10: {
        label: "課税10%",
        TaxRate: 0.1,
        calcTax: (taxExcludedAmount) => Amount.of(Math.round(taxExcludedAmount * 0.1)),
    },
    Taxable8: {
        label: "課税8%",
        TaxRate: 0.08,
        calcTax: (taxExcludedAmount) => Amount.of(Math.round(taxExcludedAmount * 0.08)),
    },
    UnTaxable: {
        label: "不課税",
        TaxRate: 0,
        calcTax: (_taxExcludedAmount) => Amount.of(0),
    },
};
const TaxCategorySchema = z.enum(TaxCategoryList);
export const TaxCategory = {
    schema: TaxCategorySchema,
    list: TaxCategoryList,
    ...TaxCategoryProperties,
};
//# sourceMappingURL=tax-category.js.map